import { IUser } from '../../global';
import isProduction from './isProduction';
import isDeveloper from './user/isDeveloper';

const canSeeDevFeature = (user: IUser | undefined) => {
  return isDeveloper(user) || !isProduction();
};

export default canSeeDevFeature;
